// Old logic: https://gitlab.zoopla.co.uk/perl-platform/codebase-v2/-/blob/master/lib/perl/Internal/Website/SEO/Meta.pm#L47
import { SearchCategory } from '../SearchContext';

const getFilteredIndexPaths = (url: string, queryParams: QueryParams) => {
    const {
        property_sub_type: propertySubType,
        feature,
        is_retirement_home: isRetirementHomeQryParam
    } = queryParams;
    const numberOfParams = Object.keys(queryParams).length;

    const isTerracedSubType = propertySubType === 'terraced';
    const isBungalowSubType = propertySubType === 'bungalow';
    const isCottageSubType = propertySubType === 'cottage';
    const hasGarden = feature === 'has_garden';
    const hasParkingGarage = feature === 'has_parking_garage';
    const isBungalow = url.includes('/bungalows/');
    const isRetirement = url.includes('/retirement/');
    const isLondonProperty = url.includes('/property/london');
    const isRetirementHome = isRetirementHomeQryParam === 'true';
    const isSale = url.includes('for-sale');

    if (
        (isTerracedSubType && numberOfParams === 2) ||
        (isBungalowSubType && numberOfParams === 2) ||
        (isBungalow && numberOfParams === 1 && isSale) ||
        (isCottageSubType && numberOfParams === 2) ||
        (hasGarden && numberOfParams === 2) ||
        (hasParkingGarage &&
            numberOfParams === 2 &&
            isLondonProperty &&
            isSale) ||
        (isRetirementHome && numberOfParams === 2) ||
        (isRetirement && numberOfParams === 1 && isSale)
    ) {
        return true;
    }

    return false;
};

type QueryParams = {
    property_sub_type?: string | string[];
    feature?: string | string[];
    is_retirement_home?: string | string[];
    search_source?: string | string[];
    property_type?: string | string[];
    'search-path'?: string | string[];
};

const isInvalidSeoKeywordSearch = (
    url: string,
    totalResults: number,
    regularListingCount: number
) => {
    return (
        url.includes('seo_is_keyword_page=1') &&
        (totalResults < 2 || regularListingCount === 1)
    );
};

export const shouldIndexPath = (
    url: string,
    query: QueryParams,
    category: SearchCategory,
    pageNumber: number,
    regularListingCount: number,
    extendedListingCount: number
) => {
    const emptyResults = regularListingCount === 0;
    const totalResults = regularListingCount + extendedListingCount;

    const { search_source: searchSource } = query;

    const isResidential = category === 'residential';
    if (!isResidential) {
        return true;
    }

    const hasJustFiltered = searchSource === 'facets';
    if (hasJustFiltered) {
        const queryParams = { ...query };
        delete queryParams['search-path'];
        const shouldIndexFilteredPath = getFilteredIndexPaths(url, queryParams);

        return shouldIndexFilteredPath;
    }

    if (pageNumber > 1 || emptyResults) {
        return false;
    }

    if (isInvalidSeoKeywordSearch(url, totalResults, regularListingCount)) {
        return false;
    }

    return true;
};
